import { createSignal, ParentProps, Setter, Show, Signal } from 'solid-js'
import styles from './st-toggle.module.css'

export class ToggleProps {
    value?: Signal<boolean>;
    label?: string;
    disabled?: boolean;
}

export default function Toggle(props: ParentProps<ToggleProps>) {
    const [checked, setChecked] = props.value ?? createSignal(props.value || false);

    const handleInput = (e: InputEvent) => {
        const target = e.currentTarget as HTMLInputElement;
        setChecked(target.checked);
    }


    return (
        <label class={styles.toggle} aria-disabled={props.disabled}>
            <input
                type="checkbox"
                class={`${styles.checkbox} sr-only`}
                checked={checked()}
                disabled={props.disabled}
                onInput={handleInput}
            />
            <span class={styles.slider} />
            <Show when={props.label}>
                <span class={styles.label}>
                    {props.label}
                </span>
            </Show>
        </label>
    );
}

Toggle.defaultProps = new ToggleProps();